import React from "react";
import cs from "classnames";
import { Icon } from "../../../shared/Icon/Icon";

interface Props {
  imageUrl?: string;
  name?: string;
  className?: string;
}

export const PersonCredentials = ({ imageUrl, className }: Props) => {
  const classes = cs(className);
  return (
    <>
      {imageUrl ? (
        <img src={imageUrl} alt="User" />
      ) : (
        <div className={classes}>
          <Icon icon="user-simple" />
        </div>
      )}
    </>
  );
};
